import React, { memo } from 'react';
import NoteIcon from 'src/images/note.png';

const DeliveryNote = ({ deliveryNote }) => {
  return (
    <>
      <div className="deliveryNoteBlock">
        <div>
          
          <img src={NoteIcon} alt="delivery-icon"/>
        </div>
        <div style={{ marginLeft: '10px' }} className="instructions">
          <p className="order-details-address-name">Delivery Instructions:</p>
          {deliveryNote?.split('\n')?.map((item, index) => (
            <i key={index} style={{ display: 'block', fontStyle: 'italic' }}>
              {item}
            </i>
          ))}
        </div>
      </div>
    </>
  );
};

export default memo(DeliveryNote);